import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { Button } from './Button';

export const PricingCard = ({ 
  title, 
  price, 
  period, 
  description, 
  features, 
  highlighted = false, 
  badge, 
  onSelect, 
  loading = false,
  buttonText = "Get Started"
}) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className={`relative p-8 rounded-3xl border-2 transition-all group ${
        highlighted 
          ? 'border-indigo-600 bg-indigo-50/30' 
          : 'border-gray-100 bg-white hover:border-indigo-200'
      }`}
    >
      {badge && (
        <div className="absolute top-4 right-4 bg-indigo-600 text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase">
          {badge}
        </div>
      )}
      
      <div className="mb-6">
        <h4 className="text-xl font-bold text-gray-900 mb-2">{title}</h4>
        <p className="text-gray-500 text-sm">{description}</p>
      </div>

      <div className="flex items-baseline gap-1 mb-8">
        <span className={`text-4xl font-extrabold ${highlighted ? 'text-indigo-600' : 'text-gray-900'}`}>
          ${price}
        </span>
        {period && <span className="text-gray-400 font-medium">/{period}</span>}
      </div>

      {features && (
        <ul className="space-y-3 mb-8">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
              <SafeIcon name="Check" className="text-green-500" />
              {feature}
            </li>
          ))}
        </ul>
      )}

      <Button
        onClick={onSelect}
        className={`w-full py-4 text-lg ${
          highlighted 
            ? 'shadow-lg shadow-indigo-200' 
            : ''
        }`}
        variant={highlighted ? 'primary' : 'secondary'}
        disabled={loading}
      >
        {loading ? 'Connecting to Stripe...' : buttonText}
      </Button>
    </motion.div>
  );
};
